// removed by extract-text-webpack-plugin
module.exports = {"anchor":"styles__anchor___1daOr","column1":"styles__column1___37PiN","column2":"styles__column2___23tuL","footer":"styles__footer___zEPC7","header":"styles__header___2MzbU","heading":"styles__heading___1bj-p","paragraph":"styles__paragraph___3fzEh","postHighlightContainer":"styles__postHighlightContainer___3U0Rv","textContainer":"styles__textContainer___2bGnG"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/postHighlight/styles.css
// module id = NjDn
// module chunks = 3